// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CloudIpResourceKindSchema } from '../inputTypeSchemas/CloudIpResourceKindSchema'
import { CloudIpOwnershipSchema } from '../inputTypeSchemas/CloudIpOwnershipSchema'

/////////////////////////////////////////
// CLOUD IP ALLOCATION SCHEMA
/////////////////////////////////////////

export const CloudIpAllocationSchema = z.object({
  resourceKind: CloudIpResourceKindSchema,
  ownership: CloudIpOwnershipSchema,
  id: z.string(),
  tenantId: z.string(),
  accountId: z.string(),
  ipOrCidr: z.string(),
  version: z.number().int(),
  resourceId: z.string(),
  region: z.string().nullable(),
  associatedResourceId: z.string().nullable(),
  lastSeenAt: z.coerce.date(),
  deprovisionedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type CloudIpAllocation = z.infer<typeof CloudIpAllocationSchema>

export default CloudIpAllocationSchema;
